// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"19afa3a1","498":"93d0ddf3","703":"a52ceb99"}[chunkId] + ".chunk.js";
};